module.exports = __webpack_public_path__ + "media/images/emblems/Taeuffelen-coat_of_arms-75674e7eb18a5f3ab0e4b2005f174c25.svg";